import {hasValue} from '@famly/stat_ts-utils_has-value';
import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';
import type {
    GetInstitutionSettingsQuery,
    GetInstitutionSettingsQueryVariables,
} from 'web-app/react/institution/settings/settings/__generated__/queries.api-types';
import {GetInstitutionSettings} from 'web-app/react/institution/settings/settings/queries';
import InstitutionBehaviors from 'web-app/behaviors/institution-behavior-ids';

export const usePermissions = (
    siteId: string,
): {canAddNewItem: boolean; canOverridePrice: boolean; canAddNewDiscount: boolean} => {
    const [{canAddNewItem, canOverridePrice, canAddNewDiscount}] = useTransformQuery<
        GetInstitutionSettingsQuery,
        GetInstitutionSettingsQueryVariables
    >()(
        GetInstitutionSettings,
        {
            variables: {
                institutionId: siteId,
            },
            fetchPolicy: 'cache-and-network',
        },
        ({data, loading}) => {
            if (loading || !hasValue(data)) {
                return {
                    canAddNewItem: false,
                    canOverridePrice: false,
                    canAddNewDiscount: false,
                };
            }

            const institution = data.institutions.find(site => site.id === siteId);

            const settings = institution?.settings.settingGroups.flatMap(settingGroup =>
                settingGroup.groups.map(group => group.__typename),
            );

            const behaviors = institution?.behaviors.flatMap(behavior => behavior.behaviorId);

            return {
                canAddNewItem: settings?.includes('InstitutionSettingPricing') ?? false,
                canOverridePrice: settings?.includes('InstitutionSettingPricing') ?? false,
                canAddNewDiscount: behaviors?.includes(InstitutionBehaviors.CanUseDiscountPresets) ?? false,
            };
        },
    );

    return {canAddNewItem, canOverridePrice, canAddNewDiscount};
};
